import AelfrithCamp from "assets/images/zones/AtzelsApproach/AelfrithCamp.jpg";
import Skammestein from "assets/images/zones/AtzelsApproach/Skammestein.jpg";
import HallsofEternalFrost from "assets/images/zones/AtzelsApproach/HallsofEternalFrost.jpg";
import Ivoryvale from "assets/images/zones/AtzelsApproach/Ivoryvale.jpg";
import AelfrithCampMap from "assets/images/zones/AtzelsApproach/AelfrithCampMap.jpg";
import SkammesteinMap from "assets/images/zones/AtzelsApproach/SkammesteinMap.jpg";
import HallsofEternalFrostMap from "assets/images/zones/AtzelsApproach/HallsofEternalFrostMap.jpg";
import IvoryvaleMap from "assets/images/zones/AtzelsApproach/IvoryvaleMap.jpg";

import CommonCity from "assets/images/zones/TarantiaCommonDistrict/CommonCity.jpg";
import ShantyTown from "assets/images/zones/TarantiaCommonDistrict/ShantyTown.jpg";
import IronTower from "assets/images/zones/TarantiaCommonDistrict/IronTower.jpg";
import CommonCityMap from "assets/images/zones/TarantiaCommonDistrict/CommonCityMap.jpg";
import ShantyTownMap from "assets/images/zones/TarantiaCommonDistrict/ShantyTownMap.jpg";
import IronTowerMap from "assets/images/zones/TarantiaCommonDistrict/IronTowerMap.jpg";

import Courtyard from "assets/images/zones/TarantiaNobleDistrict/Courtyard.jpg";
import CourtyardMap from "assets/images/zones/TarantiaNobleDistrict/CourtyardMap.jpg";
import MarketArea from "assets/images/zones/TarantiaNobleDistrict/MarketArea.jpg";
import MarketAreaMap from "assets/images/zones/TarantiaNobleDistrict/MarketAreaMap.jpg";

import CimmerianSettlement from "assets/images/zones/ConallsValley/CimmerianSettlement.jpg";
import MountainGlade from "assets/images/zones/ConallsValley/MountainGlade.jpg";
import CascadeFalls from "assets/images/zones/ConallsValley/CascadeFalls.jpg";
import FieldOfTheDeadEntrance from "assets/images/zones/ConallsValley/FieldOfTheDeadEntrance.jpg";
import FrostFields from "assets/images/zones/ConallsValley/FrostFields.jpg";
import CimmerianSettlementMap from "assets/images/zones/ConallsValley/CimmerianSettlementMap.jpg";
import MountainGladeMap from "assets/images/zones/ConallsValley/MountainGladeMap.jpg";
import CascadeFallsMap from "assets/images/zones/ConallsValley/CascadeFallsMap.jpg";
import FieldOfTheDeadEntranceMap from "assets/images/zones/ConallsValley/FieldOfTheDeadEntranceMap.jpg";
import FrostFieldsMap from "assets/images/zones/ConallsValley/FrostFieldsMap.jpg";

import AncientRuins from "assets/images/zones/GatewayToKhitai/AncientRuins.jpg";
import MidSteppes from "assets/images/zones/GatewayToKhitai/MidSteppes.jpg";
import MenudsjinscampWest from "assets/images/zones/GatewayToKhitai/MenudsjinscampWest.jpg";
import MenudsjinscampEast from "assets/images/zones/GatewayToKhitai/MenudsjinscampEast.jpg";
import AncientRuinsMap from "assets/images/zones/GatewayToKhitai/AncientRuinsMap.jpg";
import MidSteppesMap from "assets/images/zones/GatewayToKhitai/MidSteppesMap.jpg";
import MenudsjinscampWestMap from "assets/images/zones/GatewayToKhitai/MenudsjinscampWestMap.jpg";
import MenudsjinscampEastMap from "assets/images/zones/GatewayToKhitai/MenudsjinscampEastMap.jpg";
import TradingVillage from "assets/images/zones/GatewayToKhitai/TradingVillage.jpg";
import TradingVillageMap from "assets/images/zones/GatewayToKhitai/TradingVillageMap.jpg";

import KheshattaOasis from "assets/images/zones/Kheshatta/KheshattaOasis.jpg";
import DryOasis from "assets/images/zones/Kheshatta/DryOasis.jpg";
import KheshattaCity from "assets/images/zones/Kheshatta/KheshattaCity.jpg";
import Overlook from "assets/images/zones/Kheshatta/Overlook.jpg";
import KheshattaValley from "assets/images/zones/Kheshatta/KheshattaValley.jpg";
import KheshattaOasisMap from "assets/images/zones/Kheshatta/KheshattaOasisMap.jpg";
import DryOasisMap from "assets/images/zones/Kheshatta/DryOasisMap.jpg";
import KheshattaCityMap from "assets/images/zones/Kheshatta/KheshattaCityMap.jpg";
import OverlookMap from "assets/images/zones/Kheshatta/OverlookMap.jpg";
import KheshattaValleyMap from "assets/images/zones/Kheshatta/KheshattaValleyMap.jpg";

import Bubshur from "assets/images/zones/KhopshefProvince/Bubshur.jpg";
import Pashtun from "assets/images/zones/KhopshefProvince/Pashtun.jpg";
import WatersEdge from "assets/images/zones/KhopshefProvince/WatersEdge.jpg";
import TheShadowOfThePyramid from "assets/images/zones/KhopshefProvince/TheShadowOfThePyramid.jpg";
import Caravanserai from "assets/images/zones/KhopshefProvince/Caravanserai.jpg";
import DeepDesert from "assets/images/zones/KhopshefProvince/DeepDesert.jpg";
import BlackCastleValley from "assets/images/zones/KhopshefProvince/BlackCastleValley.jpg";
import BubshurMap from "assets/images/zones/KhopshefProvince/BubshurMap.jpg";
import PashtunMap from "assets/images/zones/KhopshefProvince/PashtunMap.jpg";
import WatersEdgeMap from "assets/images/zones/KhopshefProvince/WatersEdgeMap.jpg";
import TheShadowOfThePyramidMap from "assets/images/zones/KhopshefProvince/TheShadowOfThePyramidMap.jpg";
import CaravanseraiMap from "assets/images/zones/KhopshefProvince/CaravanseraiMap.jpg";
import DeepDesertMap from "assets/images/zones/KhopshefProvince/DeepDesertMap.jpg";
import BlackCastleValleyMap from "assets/images/zones/KhopshefProvince/BlackCastleValleyMap.jpg";

import Pennisula from "assets/images/zones/WhiteSands/Pennisula.jpg";
import SecludedCove from "assets/images/zones/WhiteSands/SecludedCove.jpg";
import PictCamp from "assets/images/zones/WhiteSands/PictCamp.jpg";
import PennisulaMap from "assets/images/zones/WhiteSands/PennisulaMap.jpg";
import SecludedCoveMap from "assets/images/zones/WhiteSands/SecludedCoveMap.jpg";
import PictCampMap from "assets/images/zones/WhiteSands/PictCampMap.jpg";

import Tesso from "assets/images/zones/WildLandsOfZelata/Tesso.jpg";
import Kerkyra from "assets/images/zones/WildLandsOfZelata/Kerkyra.jpg";
import WildHills from "assets/images/zones/WildLandsOfZelata/WildHills.jpg";
import CorvoOutskirts from "assets/images/zones/WildLandsOfZelata/CorvoOutskirts.jpg";
import AcheronianStronghold from "assets/images/zones/WildLandsOfZelata/AcheronianStronghold.jpg";
import WildPlains from "assets/images/zones/WildLandsOfZelata/WildPlains.jpg";
import TessoMap from "assets/images/zones/WildLandsOfZelata/TessoMap.jpg";
import KerkyraMap from "assets/images/zones/WildLandsOfZelata/KerkyraMap.jpg";
import WildHillsMap from "assets/images/zones/WildLandsOfZelata/WildHillsMap.jpg";
import CorvoOutskirtsMap from "assets/images/zones/WildLandsOfZelata/CorvoOutskirtsMap.jpg";
import AcheronianStrongholdMap from "assets/images/zones/WildLandsOfZelata/AcheronianStrongholdMap.jpg";
import WildPlainsMap from "assets/images/zones/WildLandsOfZelata/WildPlainsMap.jpg";

import AntheasHouse from "assets/images/zones/ThunderRiver/AntheasHouse.jpg";
import Boathouse from "assets/images/zones/ThunderRiver/Boathouse.jpg";
import Palisades from "assets/images/zones/ThunderRiver/Palisades.jpg";
import AntheasHouseMap from "assets/images/zones/ThunderRiver/AntheasHouseMap.jpg";
import BoathouseMap from "assets/images/zones/ThunderRiver/BoathouseMap.jpg";
import PalisadesMap from "assets/images/zones/ThunderRiver/PalisadesMap.jpg";

import TheWheelOfPain from "assets/images/zones/YmirsPass/TheWheelOfPain.jpg";
import TheWheelOfPainMap from "assets/images/zones/YmirsPass/TheWheelOfPainMap.jpg";
import CimmerianCamp from "assets/images/zones/YmirsPass/CimmerianCamp.jpg";
import CimmerianCampMap from "assets/images/zones/YmirsPass/CimmerianCampMap.jpg";
import RuinsEdge from "assets/images/zones/YmirsPass/RuinsEdge.jpg";
import RuinsEdgeMap from "assets/images/zones/YmirsPass/RuinsEdgeMap.jpg";
import MountainSlopes from "assets/images/zones/YmirsPass/MountainSlopes.jpg";
import MountainSlopesMap from "assets/images/zones/YmirsPass/MountainSlopesMap.jpg";
import EasternPass from "assets/images/zones/YmirsPass/EasternPass.jpg";
import EasternPassMap from "assets/images/zones/YmirsPass/EasternPassMap.jpg";

import TheHole from "assets/images/zones/NorthernGrasslands/TheHole.jpg";
import ZangXinForest from "assets/images/zones/NorthernGrasslands/ZangXinForest.jpg";
import MeiDianwafu from "assets/images/zones/NorthernGrasslands/MeiDianwafu.jpg";
import TheQuarry from "assets/images/zones/NorthernGrasslands/TheQuarry.jpg";
import TheHoleMap from "assets/images/zones/NorthernGrasslands/TheHoleMap.jpg";
import ZangXinForestMap from "assets/images/zones/NorthernGrasslands/ZangXinForestMap.jpg";
import MeiDianwafuMap from "assets/images/zones/NorthernGrasslands/MeiDianwafuMap.jpg";
import TheQuarryMap from "assets/images/zones/NorthernGrasslands/TheQuarryMap.jpg";
import RedCliffInnMap from "assets/images/zones/NorthernGrasslands/RedCliffInnMap.jpg";
import RedCliffInn from "assets/images/zones/NorthernGrasslands/RedCliffInn.jpg";
import PinPinMap from "assets/images/zones/NorthernGrasslands/PinPinMap.jpg";
import PinPin from "assets/images/zones/NorthernGrasslands/PinPin.jpg";
import ChowMap from "assets/images/zones/NorthernGrasslands/ChowMap.jpg";
import Chow from "assets/images/zones/NorthernGrasslands/Chow.jpg";
import WarmonkPassageMap from "assets/images/zones/NorthernGrasslands/WarmonkPassageMap.jpg";
import WarmonkPassage from "assets/images/zones/NorthernGrasslands/WarmonkPassage.jpg";
import ZangXinCampMap from "assets/images/zones/NorthernGrasslands/ZangXinCampMap.jpg";
import ZangXinCamp from "assets/images/zones/NorthernGrasslands/ZangXinCamp.jpg";

import JuJia from "assets/images/zones/Paikang/JuJia.jpg";
import RiceFields from "assets/images/zones/Paikang/RiceFields.jpg";
import JuJiaMap from "assets/images/zones/Paikang/JuJiaMap.jpg";
import RiceFieldsMap from "assets/images/zones/Paikang/RiceFieldsMap.jpg";
import Docks from "assets/images/zones/Paikang/Docks.jpg";
import DocksMap from "assets/images/zones/Paikang/DocksMap.jpg";
import Baishan from "assets/images/zones/Paikang/Baishan.jpg";
import BaishanMap from "assets/images/zones/Paikang/BaishanMap.jpg";
import HeavensLake from "assets/images/zones/Paikang/HeavensLake.jpg";
import HeavensLakeMap from "assets/images/zones/Paikang/HeavensLakeMap.jpg";
import PaikangEntrance from "assets/images/zones/Paikang/PaikangEntrance.jpg";
import PaikangEntranceMap from "assets/images/zones/Paikang/PaikangEntranceMap.jpg";

import ArdashirArena from "assets/images/zones/CoastOfArdashir/ArdashirArena.jpg";
import GoldenPalace from "assets/images/zones/CoastOfArdashir/GoldenPalace.jpg";
import LoggingCamp from "assets/images/zones/CoastOfArdashir/LoggingCamp.jpg";
import ArdashirArenaMap from "assets/images/zones/CoastOfArdashir/ArdashirArenaMap.jpg";
import GoldenPalaceMap from "assets/images/zones/CoastOfArdashir/GoldenPalaceMap.jpg";
import LoggingCampMap from "assets/images/zones/CoastOfArdashir/LoggingCampMap.jpg";
import ArdashirCity from "assets/images/zones/CoastOfArdashir/ArdashirCity.jpg";
import ArdashirCityMap from "assets/images/zones/CoastOfArdashir/ArdashirCityMap.jpg";
import CanyonOutpost from "assets/images/zones/CoastOfArdashir/CanyonOutpost.jpg";
import CanyonOutpostMap from "assets/images/zones/CoastOfArdashir/CanyonOutpostMap.jpg";

import ExcavationCamp from "assets/images/zones/DragonsSpine/ExcavationCamp.jpg";
import Oasis from "assets/images/zones/DragonsSpine/Oasis.jpg";
import NomadCamp from "assets/images/zones/DragonsSpine/NomadCamp.jpg";
import ShadowyCave from "assets/images/zones/DragonsSpine/ShadowyCave.jpg";
import ExcavationSite from "assets/images/zones/DragonsSpine/ExcavationSite.jpg";
import ExcavationCampMap from "assets/images/zones/DragonsSpine/ExcavationCampMap.jpg";
import OasisMap from "assets/images/zones/DragonsSpine/OasisMap.jpg";
import NomadCampMap from "assets/images/zones/DragonsSpine/NomadCampMap.jpg";
import ShadowyCaveMap from "assets/images/zones/DragonsSpine/ShadowyCaveMap.jpg";
import ExcavationSiteMap from "assets/images/zones/DragonsSpine/ExcavationSiteMap.jpg";

import ValleyHuntingLodge from "assets/images/zones/EiglophianMountains/ValleyHuntingLodge.jpg";
import EastSettlementofDinog from "assets/images/zones/EiglophianMountains/EastSettlementofDinog.jpg";
import WestSettlementofDinog from "assets/images/zones/EiglophianMountains/WestSettlementofDinog.jpg";
import MountainHuntingLodge from "assets/images/zones/EiglophianMountains/MountainHuntingLodge.jpg";
import ValleyHuntingLodgeMap from "assets/images/zones/EiglophianMountains/ValleyHuntingLodgeMap.jpg";
import EastSettlementofDinogMap from "assets/images/zones/EiglophianMountains/EastSettlementofDinogMap.jpg";
import WestSettlementofDinogMap from "assets/images/zones/EiglophianMountains/WestSettlementofDinogMap.jpg";
import MountainHuntingLodgeMap from "assets/images/zones/EiglophianMountains/MountainHuntingLodgeMap.jpg";

import Foothills from "assets/images/zones/FieldOfTheDead/Foothills.jpg";
import Crossroads from "assets/images/zones/FieldOfTheDead/Crossroads.jpg";
import SteamBridge from "assets/images/zones/FieldOfTheDead/SteamBridge.jpg";
import Graveyard from "assets/images/zones/FieldOfTheDead/Graveyard.jpg";
import FoothillsMap from "assets/images/zones/FieldOfTheDead/FoothillsMap.jpg";
import CrossroadsMap from "assets/images/zones/FieldOfTheDead/CrossroadsMap.jpg";
import SteamBridgeMap from "assets/images/zones/FieldOfTheDead/SteamBridgeMap.jpg";
import GraveyardMap from "assets/images/zones/FieldOfTheDead/GraveyardMap.jpg";
import Lookout from "assets/images/zones/FieldOfTheDead/Lookout.jpg";
import LookoutMap from "assets/images/zones/FieldOfTheDead/LookoutMap.jpg";

import BorderRange from "assets/images/zones/BorderRange/BorderRange.jpg";
import BorderRangeMap from "assets/images/zones/BorderRange/BorderRangeMap.jpg";

import CaennaVillage from "assets/images/zones/BorderKingdomsAquilonianEnd/CaennaVillage.jpg";
import SupplyCamp from "assets/images/zones/BorderKingdomsAquilonianEnd/SupplyCamp.jpg";
import OldCoachHouse from "assets/images/zones/BorderKingdomsAquilonianEnd/OldCoachHouse.jpg";
import CaennaVillageMap from "assets/images/zones/BorderKingdomsAquilonianEnd/CaennaVillageMap.jpg";
import SupplyCampMap from "assets/images/zones/BorderKingdomsAquilonianEnd/SupplyCampMap.jpg";
import OldCoachHouseMap from "assets/images/zones/BorderKingdomsAquilonianEnd/OldCoachHouseMap.jpg";

import Nakaset from "assets/images/zones/BorderToKush/Nakaset.jpg";
import BlackWater from "assets/images/zones/BorderToKush/BlackWater.jpg";
import NakasetMap from "assets/images/zones/BorderToKush/NakasetMap.jpg";
import BlackWaterMap from "assets/images/zones/BorderToKush/BlackWaterMap.jpg";

import BrandocVillageEast from "assets/images/zones/BorderKingdomsCimmerianEnd/BrandocVillageEast.jpg";
import BrandocVillageWest from "assets/images/zones/BorderKingdomsCimmerianEnd/BrandocVillageWest.jpg";
import CimmerianEndCentral from "assets/images/zones/BorderKingdomsCimmerianEnd/CimmerianEndCentral.jpg";
import BrandocVillageEastMap from "assets/images/zones/BorderKingdomsCimmerianEnd/BrandocVillageEastMap.jpg";
import BrandocVillageWestMap from "assets/images/zones/BorderKingdomsCimmerianEnd/BrandocVillageWestMap.jpg";
import CimmerianEndCentralMap from "assets/images/zones/BorderKingdomsCimmerianEnd/CimmerianEndCentralMap.jpg";

import ChosainEntrance from "assets/images/zones/ChosainProvince/ChosainEntrance.jpg";
import ChosainEntranceMap from "assets/images/zones/ChosainProvince/ChosainEntranceMap.jpg";
import ChosainCrossroads from "assets/images/zones/ChosainProvince/ChosainCrossroads.jpg";
import ChosainCrossroadsMap from "assets/images/zones/ChosainProvince/ChosainCrossroadsMap.jpg";
import GunHai from "assets/images/zones/ChosainProvince/GunHai.jpg";
import GunHaiMap from "assets/images/zones/ChosainProvince/GunHaiMap.jpg";
import Shaulun from "assets/images/zones/ChosainProvince/Shaulun.jpg";
import ShaulunMap from "assets/images/zones/ChosainProvince/ShaulunMap.jpg";

import Fengdu from "assets/images/zones/KaraKorum/Fengdu.jpg";
import FengduMap from "assets/images/zones/KaraKorum/FengduMap.jpg";
import Marshes from "assets/images/zones/KaraKorum/Marshes.jpg";
import MarshesMap from "assets/images/zones/KaraKorum/MarshesMap.jpg";

export const MapThumbnailIcons: any = {
  1020:{
    10201: Foothills,
    10202: Crossroads,
    10203: SteamBridge,
    10204: Graveyard,
    10205: Lookout
  },
  1050:{
    10501: ValleyHuntingLodge,
    10502: EastSettlementofDinog,
    10503: WestSettlementofDinog,
    10504: MountainHuntingLodge
  },
  1080:{
    10801: Skammestein,
    10802: HallsofEternalFrost,
    10803: AelfrithCamp,
    10804: Ivoryvale
  },
  2010:{
    20101: Courtyard,
    20102: MarketArea
  },
  2020:{
    20201: CommonCity,
    20202: ShantyTown,
    20203: IronTower
  },
  1010:{
    10101: CimmerianSettlement,
    10102: MountainGlade,
    10103: CascadeFalls,
    10104: FieldOfTheDeadEntrance,
    10105: FrostFields,
  },
  6001:{
    60011: AncientRuins,
    60012: MidSteppes,
    60013: MenudsjinscampWest,
    60014: MenudsjinscampEast,
    60015: TradingVillage
  },
  3030:{
    30301: KheshattaOasis,
    30302: DryOasis,
    30303: KheshattaCity,
    30304: Overlook,
    30305: KheshattaValley
  },
  3020:{
    30201: Bubshur,
    30202: Pashtun,
    30203: WatersEdge,
    30204: TheShadowOfThePyramid,
    30205: Caravanserai,
    30206: DeepDesert,
    30207: BlackCastleValley
  },
  3071:{
    30711: ExcavationCamp,
    30712: ShadowyCave,
    30713: NomadCamp,
    30714: Oasis,
    30715: ExcavationSite
  },
  6100: {
    61001: TheHole,
    61002: ZangXinForest,
    61003: MeiDianwafu,
    61004: TheQuarry,
    61005: RedCliffInn,
    61006: PinPin,
    61007: Chow,
    61008: WarmonkPassage,
    61009: ZangXinCamp,
  },
  6200: {
    62001: Fengdu,
    62002: Marshes
  },
  6300: {
    63001: ChosainEntrance,
    63002: ChosainCrossroads,
    63003: GunHai,
    63004: Shaulun
  },
  6400: {
    64001: RiceFields,
    64002: JuJia,
    64003: Docks,
    64004: Baishan,
    64005: HeavensLake,
    64006: PaikangEntrance
  },
  7000: {
    70001: ArdashirArena,
    70002: GoldenPalace,
    70003: LoggingCamp,
    70004: ArdashirCity,
    70005: CanyonOutpost
  },
  10800:{
    108001: Pennisula,
    108002: SecludedCove,
    108003: PictCamp
  },
  2080:{
    20801: Tesso,
    20802: Kerkyra,
    20803: WildHills,
    20804: CorvoOutskirts,
    20805: AcheronianStronghold,
    20806: WildPlains,
  },
  2090:{
    20901: AntheasHouse,
    20902: Boathouse,
    20903: Palisades,
  },
  1090:{
    10901: TheWheelOfPain,
    10902: CimmerianCamp,
    10903: RuinsEdge,
    10904: MountainSlopes,
    10905: EasternPass
  },
  2084:{
    20841: BorderRange
  },
  12070:{
    120701: CaennaVillage,
    120702: SupplyCamp,
    120703: OldCoachHouse
  },
  13050:{
    130501: BlackWater,
    130502: Nakaset
  },
  11040:{
    110401: BrandocVillageEast,
    110402: BrandocVillageWest,
    110403: CimmerianEndCentral
  }
}

export const MapIcons: any = {
  1020:{
    10201: FoothillsMap,
    10202: CrossroadsMap,
    10203: SteamBridgeMap,
    10204: GraveyardMap,
    10205: LookoutMap
  },
  1050:{
    10501: ValleyHuntingLodgeMap,
    10502: EastSettlementofDinogMap,
    10503: WestSettlementofDinogMap,
    10504: MountainHuntingLodgeMap
  },
  1080:{
    10801: SkammesteinMap,
    10802: HallsofEternalFrostMap,
    10803: AelfrithCampMap,
    10804: IvoryvaleMap
  },
  2010:{
    20101: CourtyardMap,
    20102: MarketAreaMap
  },
  2020:{
    20201: CommonCityMap,
    20202: ShantyTownMap,
    20203: IronTowerMap
  },
  1010:{
    10101: CimmerianSettlementMap,
    10102: MountainGladeMap,
    10103: CascadeFallsMap,
    10104: FieldOfTheDeadEntranceMap,
    10105: FrostFieldsMap,
  },
  6001:{
    60011: AncientRuinsMap,
    60012: MidSteppesMap,
    60013: MenudsjinscampWestMap,
    60014: MenudsjinscampEastMap,
    60015: TradingVillageMap
  },
  3030:{
    30301: KheshattaOasisMap,
    30302: DryOasisMap,
    30303: KheshattaCityMap,
    30304: OverlookMap,
    30305: KheshattaValleyMap
  },
  3020:{
    30201: BubshurMap,
    30202: PashtunMap,
    30203: WatersEdgeMap,
    30204: TheShadowOfThePyramidMap,
    30205: CaravanseraiMap,
    30206: DeepDesertMap,
    30207: BlackCastleValleyMap
  },
  3071:{
    30711: ExcavationCampMap,
    30712: ShadowyCaveMap,
    30713: NomadCampMap,
    30714: OasisMap,
    30715: ExcavationSiteMap
  },
  6100: {
    61001: TheHoleMap,
    61002: ZangXinForestMap,
    61003: MeiDianwafuMap,
    61004: TheQuarryMap,
    61005: RedCliffInnMap,
    61006: PinPinMap,
    61007: ChowMap,
    61008: WarmonkPassageMap,
    61009: ZangXinCampMap,
  },
  6200: {
    62001: FengduMap,
    62002: MarshesMap
  },
  6300: {
    63001: ChosainEntranceMap,
    63002: ChosainCrossroadsMap,
    63003: GunHaiMap,
    63004: ShaulunMap
  },
  6400: {
    64001: RiceFieldsMap,
    64002: JuJiaMap,
    64003: DocksMap,
    64004: BaishanMap,
    64005: HeavensLakeMap,
    64006: PaikangEntranceMap
  },
  7000: {
    70001: ArdashirArenaMap,
    70002: GoldenPalaceMap,
    70003: LoggingCampMap,
    70004: ArdashirCityMap,
    70005: CanyonOutpostMap
  },
  10800:{
    108001: PennisulaMap,
    108002: SecludedCoveMap,
    108003: PictCampMap
  },
  2080:{
    20801: TessoMap,
    20802: KerkyraMap,
    20803: WildHillsMap,
    20804: CorvoOutskirtsMap,
    20805: AcheronianStrongholdMap,
    20806: WildPlainsMap,
  },
  2090:{
    20901: AntheasHouseMap,
    20902: BoathouseMap,
    20903: PalisadesMap,
  },
  1090:{
    10901: TheWheelOfPainMap,
    10902: CimmerianCampMap,
    10903: RuinsEdgeMap,
    10904: MountainSlopesMap,
    10905: EasternPassMap
  },
  2084:{
    20841: BorderRangeMap
  },
  12070:{
    120701: CaennaVillageMap,
    120702: SupplyCampMap,
    120703: OldCoachHouseMap
  },
  13050:{
    130501: BlackWaterMap,
    130502: NakasetMap
  },
  11040:{
    110401: BrandocVillageEastMap,
    110402: BrandocVillageWestMap,
    110403: CimmerianEndCentralMap
  }
}

export const ZoneHightlightIcons: any = {
  1020:Foothills,
  1050:EastSettlementofDinog,
  1080:Skammestein,
  2010: Courtyard,
  2020:IronTower,
  1010:CimmerianSettlement,
  6001:TradingVillage,
  3030:KheshattaOasis,
  3020:Bubshur,
  3071:Oasis,
  6100: PinPin,
  6200: Fengdu,
  6300: ChosainEntrance,
  6400: JuJia,
  7000: ArdashirCity,
  10800:Pennisula,
  2080: Tesso,
  2090: Palisades,
  1090: TheWheelOfPain,
  2084: BorderRange,
  12070:SupplyCamp,
  13050:BlackWater,
  11040:BrandocVillageEast,
}